import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Sidebar from "./components/Sidebar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Flights from "./pages/Flights";
import Hotels from "./pages/Hotels";
import CarRental from "./pages/CarRental";
import Team from "./pages/Team";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Race from "./pages/Race";
import Hotel from "./pages/Hotel";
import User from "./pages/User";
import LoginAlt from "./pages/LoginAlt";
import RaceAttendes from "./pages/RaceAttendes";
import AirportHotel from "./pages/AirportHotel";
import TravelSummary from "./pages/TravelSummary";
import { AuthProvider } from "./context/AuthContext";
import ProtectedLayout from "./components/ProtectedLayout";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Login har ingen sidebar */}
          <Route path="/" element={<LoginAlt />} />

          {/* Skyddade sidor */}
          <Route
            element={
              <ProtectedRoute>
                <ProtectedLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/home" element={<Home />} />
            <Route path="/flights" element={<Flights />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/car-rental" element={<CarRental />} />
            <Route path="/team" element={<Team />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/races/:id" element={<Race />} />
            <Route path="/races/:id/travel-summary" element={<TravelSummary />} />
            <Route path="/races/:id/attendees" element={<RaceAttendes />} />
            <Route path="/airport-hotel/:raceId/:userId" element={<AirportHotel />} />
            <Route path="/hotels/:id" element={<Hotel />} />
            <Route path="/users/:id" element={<User />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
